<template>
	<div class="sk-widget sk-widget-messaging-banner">
		<div>
			<i class="sk-icon-gift-solid"></i>
			<div>
				<div>
					<div class="messaging-banner-title">{{ title }}</div>
					<div class="messaging-banner-body">{{ body }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.sk-widget-messaging-banner {
	background: var(--sk-grey-bg);
	border: 1px solid var(--gR-white2);
	color: var(--gR-base-80);
	min-height: 85px;
	box-shadow: none;
}

.sk-widget-messaging-banner i {
	color: var(--gR-base-80);
	font-size: 20px;
	margin-right: 20px;
}

.sk-widget-messaging-banner div {
	color: var(--gR-base-80);
}

.sk-widget-messaging-banner > div {
	display: flex;
	align-items: center;
}

.messaging-banner-title {
	font-size: 14px;
	font-weight: 600;
	margin-bottom: 7px;
}

.messaging-banner-body {
	font-size: 10px;
}
</style>

<script>
export default {
	name: "CartCheckoutBanner",
	props: {
		title: String,
		body: String
	}
}
</script>